import React, { useEffect } from "react";
import {
  personalDataReducer,
  mapStateToProps,
  mapDispatchToProps,
} from "./PersonalData.store";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import { connect } from "react-redux";
import PersonalData from "../../library/PersonalData/PersonalData";
import LoadingSpinner from "../../ui-library/LoadingSpinner/LoadingSpinner";

export const SmartPersonalData = (props) => {
  const {
    onClose,
    username,
    yearBirth,
    fetchParticipant,
    participantId,
    resetState,
  } = props;

  useEffect(() => {
    if (participantId) {
      fetchParticipant(participantId);
    }
  }, [participantId, fetchParticipant]);

  const clearFormAndClose = () => {
    resetState();
    onClose();
  };

  return (
    <>
      {username && yearBirth ? (
        <PersonalData
          onClose={clearFormAndClose}
          username={username}
          yearBirth={yearBirth}
        />
      ) : (
        <LoadingSpinner />
      )}
    </>
  );
};

export default dynamic(
  "personalDataReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(personalDataReducer)
)(connect(mapStateToProps, mapDispatchToProps)(SmartPersonalData));
